module.exports = __webpack_public_path__ + "img/30.773a74b1.svg";